@if (!showSplitPreview()) {
  <div
    class="color-picker-preview"
    [class.is-null]="isNullMode()"
    [style.--color]="background()"
    [style.--preview-size.px]="size"
    [ngpPopoverTrigger]="pickerPopover"
    [ngpPopoverTriggerContainer]="popoverContainer()"
    [ngpPopoverTriggerCloseOnOutsideClick]="false"
    (ngpPopoverTriggerOpenChange)="onPopoverOpenChange($event)"
    #popoverTriggerRef="ngpPopoverTrigger"
  ></div>
}

@if (showSplitPreview()) {
  <div
    class="color-picker-preview color-picker-preview--split"
    [style.--preview-size.px]="size"
    [ngpPopoverTrigger]="pickerPopover"
    [ngpPopoverTriggerContainer]="popoverContainer()"
    [ngpPopoverTriggerCloseOnOutsideClick]="false"
    (ngpPopoverTriggerOpenChange)="onPopoverOpenChange($event)"
    #popoverTriggerRef="ngpPopoverTrigger"
  >
    <div [style.--color]="leftColor()"></div>
    <div [style.--color]="rightColor()" [class.is-null]="isNullMode()"></div>
  </div>
}

<ng-template #pickerPopover>
  <div
    ngpPopover
    (keydown)="onPickerKeyDown($event)"
    class="color-picker-popover"
  >
    <div class="color-picker">
      <div class="color-picker__left-panel">
        @if (hasCustomPresets()) {
          <div class="preset-tabs" role="tablist">
            <button
              type="button"
              role="tab"
              class="preset-tab"
              [class.active]="activePresetTab() === 'custom'"
              [attr.aria-selected]="activePresetTab() === 'custom'"
              (click)="selectPresetTab('custom')"
            >
              {{ "color-picker.tab.custom" | translate }}
            </button>
            <button
              type="button"
              role="tab"
              class="preset-tab"
              [class.active]="activePresetTab() === 'default'"
              [attr.aria-selected]="activePresetTab() === 'default'"
              (click)="selectPresetTab('default')"
            >
              {{ "color-picker.tab.default" | translate }}
            </button>
          </div>
        }
        <div class="presets">
          @for (preset of presets(); track preset) {
            <button
              type="button"
              class="preset"
              [style.--color]="preset"
              [class.selected]="selectedPreset() === preset"
              (click)="onPresetClick(preset)"
            ></button>
          }
          <button
            type="button"
            class="preset preset--transparent"
            [class.selected]="isTransparentSelected()"
            (click)="onTransparentPresetClick()"
          ></button>
        </div>

        @if (allowNullColor) {
          <sui-button
            variant="danger"
            [leadingIcon]="faCircleXmark"
            style="width: 100%"
            (click)="onRemoveColorClick()"
          >
            {{ "btn.remove-color" | translate }}
          </sui-button>
        }
      </div>

      <div class="color-picker__divider"></div>

      <div class="color-picker__right-panel">
        <div class="color-picker-controls">
          <div #pickrHost class="pickr-host"></div>
          <input
            type="text"
            class="color-picker-input"
            [value]="hexInput()"
            [disabled]="isNullMode()"
            (input)="onHexInputChange($event)"
            [placeholder]="isNullMode() ? 'No color' : ''"
          />
        </div>

        <div class="button-group">
          <sui-button
            variant="secondary"
            [leadingIcon]="faTimes"
            (click)="cancel()"
          >
            {{ "btn.cancel" | translate }}
          </sui-button>
          <sui-button
            variant="primary"
            [leadingIcon]="faFloppyDisk"
            (click)="apply()"
          >
            {{ "btn.save" | translate }}
          </sui-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
